import { UrlFormatter } from '@ers/helpers/';
import { MessagesTypes } from '.';


export default class Message {
    constructor({ body, attachments }) {
        this.body = this.findAndFormatUrls(body);
        this.createDate = new Date();
        this.attachments = attachments;
        this.type = MessagesTypes.sent;
    }

    formatUrl= (url) => new UrlFormatter(url).format();

    findAndFormatUrls(body) {
        return body.replace(
            /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/g,
            this.formatUrl
        );
    }

    get value() {
        return {
            body: this.body,
            attachments: this.attachments,
            createDate: this.createDate.toISOString(),
            type: this.type
        };
    }
}